import moment from "moment";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { subsDashboardApi, SubsDashboardStats, SubsDashboardTimeRange } from "./dashboard.api";

interface SubsDashboardState {
  stats: SubsDashboardStats | null;
  dashboardTimeRange: SubsDashboardTimeRange;
  loading: boolean;
  error: string | null;
  lastUpdated: string | null;
}

const initialState: SubsDashboardState = {
  stats: null,
  dashboardTimeRange: "30d",
  loading: false,
  error: null,
  lastUpdated: null,
};

export const fetchSubsDashboardStats = createAsyncThunk(
  "subsDashboard/fetchStats",
  async (timeRange: SubsDashboardTimeRange | undefined, { getState, rejectWithValue }) => {
    try {
      const range = timeRange ?? (getState() as { subsDashboard: SubsDashboardState }).subsDashboard.dashboardTimeRange;
      return await subsDashboardApi.getDashboardStats(range);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : "Failed to fetch dashboard stats");
    }
  }
);

const subsDashboardSlice = createSlice({
  name: "subsDashboard",
  initialState,
  reducers: {
    setDashboardTimeRange: (state, action: PayloadAction<SubsDashboardTimeRange>) => {
      state.dashboardTimeRange = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearStats: (state) => {
      state.stats = null;
      state.lastUpdated = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch dashboard stats
      .addCase(fetchSubsDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubsDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload;
        state.lastUpdated = moment().toISOString();
        state.error = null;
      })
      .addCase(fetchSubsDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setDashboardTimeRange, clearError, clearStats } = subsDashboardSlice.actions;
export default subsDashboardSlice.reducer;



